import { render, staticRenderFns } from "./SalesTaxes.vue?vue&type=template&id=34ba1b83&"
import script from "../js/SalesTaxes.vue?vue&type=script&lang=js&"
export * from "../js/SalesTaxes.vue?vue&type=script&lang=js&"
import style0 from "./SalesTaxes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports